import LocalizedLink from '@components/Localization/LocalizedLink'
import { Text } from '@components/gassan-ui/Typography/Text'
import { Box } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export const AccountCreationField: FC = () => {
  const { t } = useTranslation('forms')

  return (
    <Box gridColumn="span 12" mt="1rem">
      <Text>
        {t('wantToCreateAccount', { ns: 'other' })}
        <LocalizedLink href={t('account.create.url', { ns: 'navigation' })} passHref>
          <a>{t('here', { ns: 'other' })}</a>
        </LocalizedLink>
        .
      </Text>
    </Box>
  )
}
